/**
 * What an admin may do to a mission's hourly rate (JBWEB-1139, JBWEB-1143).
 *
 * Twin of api/utils/validateSalaryChange.js — same rules, same wording. The api
 * refuses; this is what lets the form say so before the admin gets there, in the
 * edit form itself rather than in the confirmation modal.
 *
 * Two rules, and they do not start at the same moment:
 *
 * - **below the minimum wage** — refused always, contract or not.
 * - **lowering the rate** — refused only once a contract exists. Until then the
 *   admin is still correcting what they are about to send.
 */

const asNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed =
    typeof value === 'number'
      ? value
      : parseFloat(String(value).replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : null;
};

const format = (value) => value.toFixed(2).replace('.', ',');

export const validateSalaryChange = ({
  before,
  after,
  hasContract,
  minimumWage,
}) => {
  const next = asNumber(after);
  if (next === null) {
    return {
      code: 'SALARY_INVALID',
      message: "Le salaire renseigné n'est pas un montant valide.",
    };
  }

  const previous = asNumber(before);
  if (hasContract && previous !== null && next < previous) {
    return {
      code: 'SALARY_DECREASE_FORBIDDEN',
      message: `Le salaire ne peut pas être abaissé une fois le contrat généré (${format(
        previous
      )} €).`,
    };
  }

  const floor = asNumber(minimumWage);
  if (floor !== null && next < floor) {
    return {
      code: 'SALARY_BELOW_MINIMUM_WAGE',
      message: `Le salaire ne peut pas être inférieur au SMIC (${format(
        floor
      )} €).`,
    };
  }

  return null;
};
